import analysisMapModule from "./analysisMapModule"
import analysisMapView from "./analysisMapView.html"

analysisMapModule.config(["$stateProvider", ($stateProvider) => {
    $stateProvider.state("r2.analysisMap", {
        data: {
            pageTitle: "{{'title.r2.analysisMap' | translate}}",
            group: "group.r2.programming.analysisMap"
        },
        url: "/analysisMap?routingSessionIdentifier",
        template: analysisMapView,
        controller: "analysisMapController",
        onEnter: ["$stateParams", "supplyService", function ($stateParams, supplyService) {
            supplyService.restrictSession($stateParams.routingSessionIdentifier)
        }]
    })
}])
